/**
 * workspace 配下の pathname から AI 専用 route かどうかを判定する。
 *
 * App Router では `/[lang]/[workspaceId]/ai` 配下を AI 画面として扱うため、
 * layout 周辺の「開いているが見せない panel」判定はこの helper に寄せる。
 */
export function isAiPagePathname(pathname: string | null | undefined) {
  const pathSegments = pathname?.split("/").filter(Boolean) ?? [];
  return pathSegments[2] === "ai";
}
